import axios from "@/axios";
import {Module} from "vuex";

const state = () => ({
    shires: []
});

const getters = {
    getShires(state: any){
        return state.shires;
    }
};
const actions = {
    async fetchShires({commit}: any, regionId: any){
        const response = await axios.get('/blog/shire/'+regionId);
        commit('saveShires', response.data);
    },
    async fetchShiresWithState({commit}: any, stateId: any){
        const response = await axios.get('/blog/shiresWithState/'+stateId);
        commit('saveShires', response.data);
    }
};
const mutations = {
    saveShires(state: any, payload: any){
        state.shires = payload;
        localStorage.setItem('shires',JSON.stringify(state.shires))
    }
};

export const shires: Module<any, any> = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}